<template>
  <div class="page">
    <breadcrumb></breadcrumb>
    <div class="enterprise-register">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-position="right"
        label-width="130px"
      >
        <div class="form-section">
          <h3 class="section-title">企业用户注册</h3>
          <!-- 单位性质，单位名称 -->
          <div class="form-row">
            <el-form-item label="单位性质" prop="organization">
              <el-select
                v-model="formData.organization"
                placeholder="请选择单位性质"
              >
                <el-option label="行政事业" value="行政事业"></el-option>
                <el-option label="社会组织" value="社会组织"></el-option>
                <el-option label="企业" value="企业"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位名称" prop="companyName">
              <el-input
                v-model="formData.companyName"
                placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 统一信用代码，证件图片 -->
          <div class="form-row">
            <el-form-item label="统一信用代码" prop="unifiedCreditCode">
              <el-input
                v-model="formData.unifiedCreditCode"
                placeholder="请输入统一信用代码"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="证件图片"
              prop="unifiedCreditCodeImage"
              required
            >
              <el-upload
                :action="uploadUrl"
                accept="image/jpeg,image/png"
                :before-upload="beforeUpload"
                :on-success="handleUploadSuccess"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="formData.unifiedCreditCodeImage"
                list-type="picture"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传 JPG/PNG 图片，且不超过 2MB
                </div>
              </el-upload>
            </el-form-item>
          </div>
          <!-- 地址，所属区域 -->
          <div class="form-row">
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="formData.address"
                placeholder="地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属区域" prop="region">
              <el-select v-model="formData.region" placeholder="请选择所属区域">
                <el-option label="‌东区" value="‌东区"></el-option>
                <el-option label="‌西区" value="‌西区"></el-option>
                <el-option label="仁和区" value="仁和区"></el-option>
                <el-option label="米易县" value="米易县"></el-option>
                <el-option label="‌盐边县‌" value="‌盐边县‌"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 联系人，联系电话-->
          <div class="form-row">
            <el-form-item label="联系人" prop="contactName">
              <el-input
                v-model="formData.contactName"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model="formData.contactPhone"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 当单位性质为行政事业时，需要填写办公电话,邮箱不必填写 -->
          <div class="form-row" v-if="formData.organization === '行政事业'">
            <el-form-item label="办公电话" prop="officePhone">
              <el-input
                v-model="formData.officePhone"
                placeholder="请输入办公电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 当单位性质为社会组织时，需要填写业务范围，法定代表人，法定代表人联系电话 -->
          <div class="form-row" v-if="formData.organization === '社会组织'">
            <el-form-item label="法定代表人" prop="legalRepresentative">
              <el-input
                v-model="formData.legalRepresentative"
                placeholder="请输入法定代表人"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="代表人联系电话"
              prop="legalRepresentativePhone"
            >
              <el-input
                v-model="formData.legalRepresentativePhone"
                placeholder="请输入法定代表人联系电话"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-row" v-if="formData.organization === '社会组织'">
            <el-form-item label="业务范围" prop="businessScope">
              <el-input
                v-model="formData.businessScope"
                placeholder="请输入业务范围"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 当单位性质为企业时，需要填写法定代表人，法定代表人联系电话 -->
          <div class="form-row" v-if="formData.organization === '企业'">
            <el-form-item label="法定代表人" prop="legalRepresentative">
              <el-input
                v-model="formData.legalRepresentative"
                placeholder="请输入法定代表人"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="代表人联系电话"
              prop="legalRepresentativePhone"
            >
              <el-input
                v-model="formData.legalRepresentativePhone"
                placeholder="请输入法定代表人联系电话"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-row" v-if="formData.organization === '企业'">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="formData.email"
                placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- 提交说明 -->
        <div class="form-section">
          <h3 class="section-title">提交说明</h3>
          <el-form-item label="提交说明" prop="submitInstructions">
            <el-input
              v-model="formData.submitInstructions"
              type="textarea"
              :rows="4"
              placeholder="请输入提交说明"
            ></el-input>
          </el-form-item>
        </div>

        <!-- 表单操作按钮 -->
        <div class="form-actions">
          <el-button
            type="warning"
            @click="submitForm"
            :loading="loading"
            size="large"
          >
            {{ loading ? "提交中..." : "提交登记" }}
          </el-button>
          <!-- <el-button type="primary" @click="submitForm">提交登记</el-button>
          <el-button @click="resetForm">重置</el-button> -->
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb.vue";
import { register } from "@/api/api.js";
export default {
  name: "EnterpriseRegister",
  components: {
    breadcrumb,
  },
  data() {
    return {
      formData: {
        organization: "", //单位性质
        companyName: "", //单位名称
        unifiedCreditCode: "", //统一信用代码
        unifiedCreditCodeImage: [], //统一信用代码图片
        address: "", //地址
        region: "", //所属区域
        contactName: "", //联系人
        contactPhone: "", //联系电话
        officePhone: "", //办公电话
        businessScope: "", //业务范围
        legalRepresentative: "", //法定代表人
        legalRepresentativePhone: "", //法定代表人联系电话
        email: "", //邮箱
        personalPhoto:
          "https://oss-community.planttech.cn/huacheng/51846bdc22cc45539cbfda60fe99162d.png", //个人免冠照片
        // 提交说明
        submitInstructions: "",
      },
      rules: {
        organization: [
          { required: true, message: "请选择单位性质", trigger: "change" },
        ],
        companyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        unifiedCreditCode: [
          { required: true, message: "请输入统一信用代码", trigger: "blur" },
        ],
        unifiedCreditCodeImage: [
          { required: true, message: "请上传证件图片", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请上传图片"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        region: [
          { required: true, message: "请选择所属区域", trigger: "change" },
        ],
        contactName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!/1[3456789]\d{9}$/.test(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        officePhone: [
          { required: true, message: "请输入办公电话", trigger: "blur" },
        ],
        businessScope: [
          { required: true, message: "请输入业务范围", trigger: "blur" },
        ],
        legalRepresentative: [
          { required: true, message: "请输入法定代表人", trigger: "blur" },
        ],
        legalRepresentativePhone: [
          {
            required: true,
            message: "请输入法定代表人联系电话",
            trigger: "blur",
          },
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              // 如果值为空（null、undefined、空字符串或纯空格），则直接通过验证
              if (!value || value.trim() === "") {
                callback();
                return;
              }
              // 非空时进行正则校验
              const emailReg =
                /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
              if (!emailReg.test(value)) {
                callback(new Error("请输入正确的邮箱"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      // UI状态
      loading: false,
      uploadUrl: "https://huachenglargescreen.planttech.cn/apis/common/upload",
    };
  },
  methods: {
    // 表单操作
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          register({
            userName: this.formData.contactPhone,
            phonenumber: this.formData.contactPhone,
            origin: "company",
            registerInfoTemp: this.formData,
            email: this.formData.email,
          })
            .then((res) => {
              this.loading = false;
              if (res.data.code == 200 && res.data.data) {
                this.$message.success("企业用户注册成功");
                setTimeout(() => this.$router.replace("/index"), 1000);
              } else {
                this.$message.error("提交失败，请重新提交");
              }
            })
            .catch(() => {
              this.loading = false;
              this.$message.error("提交异常");
            });
        } else {
          this.$message.error("表单验证失败，请检查填写内容！");
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    /* 上传图片的操作 */
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200 && response.data) {
        // 将后端返回的图片URL赋值给当前文件的url属性
        file.url = response.data;
        // 更新整个fileList到formData中，保证每个文件对象都包含必要的name、url
        this.formData.unifiedCreditCodeImage = fileList.map((f) => ({
          name: f.name,
          url: f.url,
          uid: f.uid, // 可选，但有助于组件内部跟踪
        }));
        // 触发字段校验
        this.$refs.form.validateField("unifiedCreditCodeImage");
      } else {
        this.$message.error("上传失败，未获取到图片地址");
      }
    },
    // 删除文件回调
    handleRemove(file, fileList) {
      this.formData.unifiedCreditCodeImage = fileList.map((f) => ({
        name: f.name,
        url: f.url,
        uid: f.uid,
      }));
      this.$refs.form.validateField("unifiedCreditCodeImage");
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning("只能上传 1 个文件，请先移除当前文件");
    },
    // 上传前校验（类型+大小，2M）
    beforeUpload(file) {
      const isValidType =
        file.type === "image/jpeg" || file.type === "image/png";
      const isValidSize = file.size / 1024 / 1024 < 2;
      if (!isValidType) {
        this.$message.error("只能上传 JPG/PNG 格式的图片！");
        return false;
      }
      if (!isValidSize) {
        this.$message.error("图片大小不能超过 2MB！");
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.page {
  padding: 0 5%;
  padding-bottom: 109px;
  padding-top: 26px;
}
.enterprise-register {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.form-section {
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
}

.section-title {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 2px solid #409eff;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  gap: 20px;
  margin-top: 20px;
}

.form-row > .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  flex: 0 0 calc(50% - 10px);
  min-width: 0;
}

:deep(.el-form-item__label) {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

/* 表格样式 */
:deep(.el-table) {
  margin-bottom: 20px;
}

:deep(.el-table__fixed-right) {
  width: 100px !important;
  padding: 0 10px;
}

/* 输入框宽度调整 */
.el-input,
.el-select,
.el-date-picker {
  width: 100%;
}

::v-deep .el-table .el-input__inner {
  padding: 0;
  text-align: center;
}

.operation-button {
  border: none !important;
  background: transparent;
  font-size: 20px;
  padding: 0;
}
.operation-button-delete {
  color: #f56c6c;
}
.el-upload__tip {
  margin-top: -10px;
}
</style>